import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import { streamInfo } from '@/api/notice';
import { downloadFileFun } from '@/utils/public';
import { mapState } from 'vuex';
import { checkRediect } from '@/api/customerNotice.js';
export default {
  props: {
    messageId: {
      type: String,
      default: ''
    },
    messageInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      previewVisible: false,
      previewSrc: '',
      currentPreviewIndex: 0,
      fileType: '',
      varivaleCollection: ['${reviewFlowView}', '${reviewFlowOperate}', '${policyDetail}', '${taskList}'],
      questionnaireLoading: false,
      claimsLoading: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo,
      timerInstance: state => state.message.timerInstance,
      messageDetailVisible: state => state.message.messageDetailVisible
    })
  },
  components: {
    previewModal
  },
  watch: {
    messageInfo(val) {
      if (val && val.id) {
        let uploadFiles = val.uploadFiles && val.uploadFiles.length > 0 ? JSON.parse(val.uploadFiles) : [];
        let annexVariable = val.annexVariable && val.annexVariable.length > 0 ? val.annexVariable : [];
        val.content = this.analyzVariable(val.content);
        val.fileList = [...uploadFiles, ...annexVariable];
        this.visible = true;
        this.$store.commit('message/setMessageDetailVisible', true);
        if (this.timerInstance) {
          clearTimeout(this.timerInstance);
        }
      }
    }
  },
  methods: {
    analyzVariable(content) {
      //解析变量
      if (content.indexOf('${reviewFlowView}') > -1) {
        let text = this.$t('查看');
        let replaceStr = "<a  operate-key='${reviewFlowView}'>" + text + '</a>';
        content = content.replace('${reviewFlowView}', replaceStr);
      }
      if (content.indexOf('${policyDetail}') > -1) {
        let text = this.$t('查看');
        let replaceStr = "<a  operate-key='${policyDetail}'>" + text + '</a>';
        content = content.replace('${policyDetail}', replaceStr);
      }
      if (content.indexOf('${taskList}') > -1) {
        let text = this.$t('查看');
        let replaceStr = "<a  operate-key='${taskList}'>" + text + '</a>';
        content = content.replace('${taskList}', replaceStr);
      }
      if (content.indexOf('${reviewFlowOperate}') > -1) {
        let text = this.$t('操作');
        let replaceStr = "<a  operate-key='${reviewFlowOperate}'>" + text + '</a>';
        content = content.replace('${reviewFlowOperate}', replaceStr);
      }
      return content;
    },
    checkRouterAuth(key) {
      //检查路由权限
      let menuList = this.accountInfo.menuList;
      let flag = false;
      let loop = list => {
        list.forEach(item => {
          if (item.mark === key) {
            flag = true;
          } else if (item.children && item.children.length > 0) {
            loop(item.children);
          }
        });
      };
      loop(menuList);
      return flag;
    },
    operationHandler(e) {
      e.stopPropagation();
      let target = e.target;
      if (target) {
        let operateKey = target.getAttribute('operate-key');
        if (operateKey === '${policyDetail}') {
          // 保单详情
          this.toPolicyDetail();
        } else if (operateKey === '${taskList}') {
          if (this.accountInfo.customerId === 0) {
            //  任务列表 总系统
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
          } else {
            // 任务列表 客户端
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'task'
            });
          }
        } else if (operateKey === '${reviewFlowView}') {
          // 理赔或者问卷详情
          this.toReviewFlowView();
        } else if (operateKey === '${reviewFlowOperate}') {
          // 理赔或者问卷操作
          this.toReviewFlowOperate();
        }
      }
    },
    toReviewFlowOperate() {
      if (this.accountInfo.customerId === 0) {
        //总系统 理赔操作
        this.$message.warning(this.$t('暂无权限,请联系管理员'));
      } else {
        //客户端 理赔操作
        let reviewFlowOperate = this.messageInfo.variable.reviewFlowOperate;
        if ((reviewFlowOperate === null || reviewFlowOperate === void 0 ? void 0 : reviewFlowOperate.type) === 'claims') {
          this.toClaimOperate(reviewFlowOperate);
        } else if ((reviewFlowOperate === null || reviewFlowOperate === void 0 ? void 0 : reviewFlowOperate.type) === 'questionnaire') {
          this.toQuestionnaireOperate(reviewFlowOperate);
        }
      }
    },
    toClaimOperate(reviewFlowOperate) {
      //跳转到理赔操作
      if (!this.checkRouterAuth('customer.auditClaimsList')) {
        this.$message.warning(this.$t('暂无权限,请联系管理员'));
        return;
      } else {
        if (!this.claimsLoading) {
          this.claimsLoading = true;
          checkRediect({
            auditFlowDetailId: reviewFlowOperate.auditFlowDetailId
          }).then(res => {
            if (res.status === true) {
              this.close();
              this.cancelPre();
              this.$router.push({
                name: 'customerClaim',
                params: {
                  type: 2,
                  id: reviewFlowOperate.auditFlowDetailId,
                  policyId: reviewFlowOperate.policyId,
                  auditFlowTypeId: reviewFlowOperate.auditFlowTypeId
                }
              });
            } else {
              this.$message.warning(this.$t('暂无权限,请联系管理员'));
            }
          }).finally(() => {
            this.claimsLoading = false;
          });
        }
      }
    },
    toQuestionnaireOperate(reviewFlowOperate) {
      //跳转到问卷操作
      if (!this.checkRouterAuth('customer.auditQuestionnaireList')) {
        this.$message.warning(this.$t('暂无权限,请联系管理员'));
        return;
      } else {
        if (this.questionnaireLoading) {
          return;
        }
        this.questionnaireLoading = true;
        checkRediect({
          auditFlowDetailId: reviewFlowOperate.auditFlowDetailId
        }).then(res => {
          if (res.status === true) {
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'questionnaireReview',
              params: {
                id: reviewFlowOperate.auditFlowDetailId,
                type: 2,
                auditFlowTypeId: reviewFlowOperate.auditFlowTypeId
              }
            });
          } else {
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
          }
        }).finally(() => {
          this.questionnaireLoading = false;
        });
      }
    },
    toReviewFlowView() {
      var _this$messageInfo;
      //跳转到理赔或者问卷详情
      let reviewFlowView = (_this$messageInfo = this.messageInfo) === null || _this$messageInfo === void 0 || (_this$messageInfo = _this$messageInfo.variable) === null || _this$messageInfo === void 0 ? void 0 : _this$messageInfo.reviewFlowView;
      if (this.accountInfo.customerId === 0 && reviewFlowView) {
        //总系统 理赔详情
        if ((reviewFlowView === null || reviewFlowView === void 0 ? void 0 : reviewFlowView.type) === 'claims') {
          if (!this.checkRouterAuth('home.claimsRecordList')) {
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
            return;
          } else {
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'recordHome',
              params: {
                id: reviewFlowView.auditFlowDetailId,
                policyId: reviewFlowView.policyId,
                auditFlowTypeId: reviewFlowView.auditFlowTypeId
              }
            });
          }
        } else if ((reviewFlowView === null || reviewFlowView === void 0 ? void 0 : reviewFlowView.type) === 'questionnaire') {
          //总系统  问卷详情
          if (!this.checkRouterAuth('home.questionnaireRecord')) {
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
            return;
          } else {
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'questionnaireCheck',
              params: {
                type: 1,
                id: reviewFlowView.auditFlowDetailId,
                flowMark: 'questionnaire',
                auditFlowTypeId: reviewFlowView.auditFlowTypeId
              }
            });
          }
        }
      } else {
        if ((reviewFlowView === null || reviewFlowView === void 0 ? void 0 : reviewFlowView.type) === 'claims') {
          //客户系统理赔详情
          if (!this.checkRouterAuth('customer.auditClaimsList')) {
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
            return;
          } else {
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'customerClaim',
              params: {
                type: 1,
                id: reviewFlowView.auditFlowDetailId,
                policyId: reviewFlowView.policyId,
                auditFlowTypeId: reviewFlowView.auditFlowTypeId
              }
            });
          }
        } else if ((reviewFlowView === null || reviewFlowView === void 0 ? void 0 : reviewFlowView.type) === 'questionnaire') {
          //客户系统问卷查看
          if (!this.checkRouterAuth('customer.auditQuestionnaireList')) {
            this.$message.warning(this.$t('暂无权限,请联系管理员'));
            return;
          } else {
            this.close();
            this.cancelPre();
            this.$router.push({
              name: 'questionnaireReview',
              params: {
                id: reviewFlowView.auditFlowDetailId,
                type: 1,
                auditFlowTypeId: reviewFlowView.auditFlowTypeId
              }
            });
          }
        }
      }
    },
    toPolicyDetail() {
      // 跳转到保单详情
      if (this.accountInfo.customerId === 0) {
        var _this$messageInfo2;
        // 总系统 保单详情
        let policyDetail = (_this$messageInfo2 = this.messageInfo) === null || _this$messageInfo2 === void 0 || (_this$messageInfo2 = _this$messageInfo2.variable) === null || _this$messageInfo2 === void 0 ? void 0 : _this$messageInfo2.policyDetail;
        if (!this.isAuth('home.policyDetail') || !this.checkRouterAuth('home.policyList')) {
          this.$message.warning(this.$t('暂无权限,请联系管理员'));
        } else if (policyDetail) {
          // this.visible = false;
          // this.$store.commit('message/setMessageDetailVisible', false);
          this.close();
          this.cancelPre();
          this.$router.push({
            name: 'homePolicy',
            params: {
              id: policyDetail.policyId
            }
          });
        }
      } else {
        var _this$messageInfo3;
        // 客户端 保单详情
        let policyDetail = (_this$messageInfo3 = this.messageInfo) === null || _this$messageInfo3 === void 0 || (_this$messageInfo3 = _this$messageInfo3.variable) === null || _this$messageInfo3 === void 0 ? void 0 : _this$messageInfo3.policyDetail;
        if (!this.isAuth('customer.policyDetail') || !this.checkRouterAuth('customer.policyList')) {
          this.$message.warning(this.$t('暂无权限,请联系管理员'));
        } else if (policyDetail) {
          // this.visible = false;
          // this.$store.commit('message/setMessageDetailVisible', false);
          this.close();
          this.cancelPre();
          this.$router.push({
            name: 'customerPolicy',
            params: {
              id: policyDetail.policyId
            }
          });
        }
      }
    },
    download(item) {
      let type = item.url.substring(item.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type) || isExcel(type) || isWord(type)) {
        this.downLoadImage(item);
      } else if (isPDF(type) || isVideo(type)) {
        let filetype = isPDF(type) ? 'application/pdf' : '';
        filetype = isVideo(type) ? 'video/mpeg' : filetype;
        streamInfo({
          url: item.url
        }).then(res => {
          if (res) {
            downloadFileFun(res, filetype, item.name);
          }
        });
      }
    },
    downLoadImage(item) {
      let link = document.createElement('a');
      link.href = item.url;
      link.setAttribute('download', item.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async preview(file) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      //excel
      if (isExcel(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式
      if (isWord(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.messageInfo.fileList.findIndex(item => item.uid === file.uid);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    },
    close() {
      this.visible = false;
      //设置消息详情弹框不可见 用于判断是否弹出消息
      this.$store.commit('message/setMessageDetailVisible', false);
      //消息详情弹框关闭后，重新获取开启消息轮询
      this.$store.dispatch('message/loopPopMessageList', {});
    }
  }
};